import React from 'react';
import { Box, Image } from '@common-fe/common-fe';

import verificationBanner from '@/assets/placeholders/verify/verificationBanner.svg';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

const VerificationBackground = () => {
  const imageSrc =
    (whiteLabelingConfig?.images?.verificationBackground as string) || (verificationBanner as string);
  const isFullSize = whiteLabelingConfig?.images?.isFullSizeVerificationImage;

  if (isFullSize) {
    return (
      <Box
        data-testid="verification-background_fullscreen"
        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }}
      >
        <Image src={imageSrc} fill fit="cover" />
      </Box>
    );
  }

  return (
    <Box fill direction="column" align="stretch" justify="between">
      <Box fill></Box>
      <Box>
        <Image src={imageSrc} fill="horizontal" fit="contain" />
      </Box>
    </Box>
  );
};

export default VerificationBackground;
